const { default: Model } = require("./base/model");

class fobOrderOccurrence extends Model {
  resourceName() {
    return 'fob_order_occurrences';
  }

  fields() {
    return {
      text: '',
      occured_at: '',
    }
  }
}

export default new fobOrderOccurrence();